export default "__VITE_ASSET__DPDFguNT__"